import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import {
  CONNECT_ACCEPT_REQUEST,
  CONNECT_DENY_REQUEST,
  CONNECT_BLOCK,
  CONNECT_REQUEST_FOLLOW,
  CONNECT_DISMISS,
  CONNECT_RETRACT_REQUEST,
  ACCEPT_ACTION,
  DENY_ACTION,
  BLOCK_ACTION,
  FOLLOW_ACTION,
  DISMISS_ACTION,
  RETRACT_REQUEST_ACTION,
  IDLE
} from '../constants';

const LINK_REL_MAP = {
  [CONNECT_ACCEPT_REQUEST]: {
    title: StringConstantsMixin.strings.COMMUNITY.BELAY_CONNECTIONS.ACCEPT,
    actionKey: ACCEPT_ACTION
  },
  [CONNECT_DENY_REQUEST]: {
    title: StringConstantsMixin.strings.COMMUNITY.BELAY_CONNECTIONS.DENY,
    actionKey: DENY_ACTION
  },
  [CONNECT_BLOCK]: {
    title: StringConstantsMixin.strings.COMMUNITY.BELAY_CONNECTIONS.BLOCK,
    actionKey: BLOCK_ACTION
  },
  [CONNECT_REQUEST_FOLLOW]: {
    title: StringConstantsMixin.strings.COMMUNITY.BELAY_CONNECTIONS.FOLLOW,
    actionKey: FOLLOW_ACTION
  },
  [CONNECT_DISMISS]: {
    title: StringConstantsMixin.strings.COMMUNITY.BELAY_CONNECTIONS.DISMISS,
    actionKey: DISMISS_ACTION
  },
  [CONNECT_RETRACT_REQUEST]: {
    title: StringConstantsMixin.strings.COMMUNITY.BELAY_CONNECTIONS.UNFOLLOW,
    actionKey: RETRACT_REQUEST_ACTION
  }
};

export const setUserActionRequestState = ({ actions, ...userConnection }, actionKey, requestState) => {
  return {
    ...userConnection,
    actions: { ...actions, [actionKey]: { ...actions[actionKey], requestState } }
  };
};

export const mapBelayLinksToActions = links => {
  return Object.fromEntries(
    links.map(({ rel, href, method }) => {
      const { title, actionKey } = LINK_REL_MAP[rel];
      return [actionKey, { href, method, title, requestState: IDLE }];
    })
  );
};

export const addActionsToConnection = ({ links, ...userConnection }) => {
  return {
    ...userConnection,
    actions: mapBelayLinksToActions(links)
  };
};

export const addActionsToConnections = connections => {
  return connections.map(addActionsToConnection);
};
